import Joi from 'joi';
import type { IRecordingHeader } from './recording';
import { recordingSchema } from './recording';
import type {
  IPrepareToDownloadParams,
  IPrepareToDownloadResult,
} from './prepareToDownload';

export const searchParamsSchema = Joi.object({
  filterFullTextSlow: Joi.string(),
  filterTags: Joi.array().items(Joi.string().not().empty()),
  isLab: Joi.boolean(),
  recordedBefore: Joi.number(),
  limit: Joi.number().required().greater(0),
});

export interface ISearchParams {
  filterFullTextSlow?: string;
  filterTags?: string[];
  isLab?: boolean;
  recordedBefore?: number;
  limit: number;
}

export const updateParamsSchema = Joi.object({
  recordingId: recordingSchema.extract('recordingId'),
  tags: recordingSchema.extract('tags'),
  recognitionResults: recordingSchema.extract('recognitionResults'),
  script: recordingSchema.extract('script'),
});

export type IUpdateParams = Pick<
  IRecordingHeader,
  'recordingId' | 'tags' | 'recognitionResults' | 'script'
>;

export interface IRecordingsApi {
  recordingsSearch(params: ISearchParams): Promise<IRecordingHeader[]>;

  recordingsUpdate(params: IUpdateParams): Promise<void>;

  recordingsPrepareToDownload(
    params: IPrepareToDownloadParams
  ): Promise<IPrepareToDownloadResult>;
}
